var map = {
	"./angry.svg": 2,
	"./baffled.svg": 3,
	"./confused.svg": 4,
	"./cool.svg": 5,
	"./crying.svg": 6,
	"./evil.svg": 7,
	"./frustrated.svg": 8,
	"./grin.svg": 9,
	"./happy.svg": 10,
	"./hipster.svg": 11,
	"./neutral.svg": 12,
	"./sad.svg": 13,
	"./shocked.svg": 14,
	"./sleepy.svg": 15,
	"./smile.svg": 16,
	"./tongue.svg": 17,
	"./wink.svg": 18,
	"./wondering.svg": 19
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1;



/*****************
 ** WEBPACK FOOTER
 ** ./icons ^\.\/.*\.svg$
 ** module id = 1
 ** module chunks = 0
 **/